import { BookmarkBlockHtmlAdapterExtension } from '@blocksuite/hive-block-bookmark';
import { CodeBlockHtmlAdapterExtension } from '@blocksuite/hive-block-code';
import { DatabaseBlockHtmlAdapterExtension } from '@blocksuite/hive-block-database';
import { DividerBlockHtmlAdapterExtension } from '@blocksuite/hive-block-divider';
import {
  EmbedFigmaBlockHtmlAdapterExtension,
  EmbedGithubBlockHtmlAdapterExtension,
  EmbedIframeBlockHtmlAdapterExtension,
  EmbedLinkedDocHtmlAdapterExtension,
  EmbedLoomBlockHtmlAdapterExtension,
  EmbedSyncedDocBlockHtmlAdapterExtension,
  EmbedYoutubeBlockHtmlAdapterExtension,
} from '@blocksuite/hive-block-embed';
import { ImageBlockHtmlAdapterExtension } from '@blocksuite/hive-block-image';
import { ListBlockHtmlAdapterExtension } from '@blocksuite/hive-block-list';
import { ParagraphBlockHtmlAdapterExtension } from '@blocksuite/hive-block-paragraph';
import { RootBlockHtmlAdapterExtension } from '@blocksuite/hive-block-root';
import { TableBlockHtmlAdapterExtension } from '@blocksuite/hive-block-table';

export const defaultBlockHtmlAdapterMatchers = [
  ListBlockHtmlAdapterExtension,
  ParagraphBlockHtmlAdapterExtension,
  CodeBlockHtmlAdapterExtension,
  DividerBlockHtmlAdapterExtension,
  ImageBlockHtmlAdapterExtension,
  RootBlockHtmlAdapterExtension,
  EmbedYoutubeBlockHtmlAdapterExtension,
  EmbedFigmaBlockHtmlAdapterExtension,
  EmbedLoomBlockHtmlAdapterExtension,
  EmbedGithubBlockHtmlAdapterExtension,
  EmbedIframeBlockHtmlAdapterExtension,
  BookmarkBlockHtmlAdapterExtension,
  DatabaseBlockHtmlAdapterExtension,
  TableBlockHtmlAdapterExtension,
  EmbedLinkedDocHtmlAdapterExtension,
  EmbedSyncedDocBlockHtmlAdapterExtension,
];
